import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
// Material-UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { IARRte } from '../../../Shared/iar-rte'
import { videoTypes } from '../../../../Constants/videoTypes'
import OnlineVideos from '../../../Shared/OnlineVideos'
import './Donate.scss'
import { GetHeaderWithToken } from '../../../../../resources/Utils'
import { cloneDeep } from 'lodash'
import ChooseImage from '../../../Shared/ChooseImage'
import ChooseVideo from '../../../Shared/ChooseVideo'
import CustomDropdown from '../../../Shared/Dropdown/dropdown'
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner'
import ButtonSave from '../../../Shared/ButtonSave/ButtonSave'
import MediaThumbnail from '../../../Shared/MediaThumbnail/MediaThumbnail'
import MediaFilesMessage from '../../../Shared/MediaFilesMessage'
import { CustomSwitch } from '../../../Shared/Switch/switch'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import serviceBase from '../../../../Services/serviceBase'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import { useCMSContext } from './../../CMSContext'
import { useMenuSectionContext } from './../../MenuSection/MenuSectionContext'
import { timeout } from '../../../../Constants/timeoutTypes'
import { saveSectionVideoProcess } from 'app/Services/serviceSectionsMediaShared'
import { EncondingSectionType } from 'app/Constants/EncodingSectionType'
import SavedMessage from '../../../Shared/SavedMessage/SavedMessage'
import PrepublishButtons from 'app/Components/Shared/PrepublishButtons/PrepublishButtons'
import DonateActions from './donate-actions'
import { entitySetter } from './donateFunctions'
import PreviewContentLabel from 'app/Components/Shared/PreviewContentLabel/PreviewContentLabel'
import { EmptyTagsTypes } from 'app/Constants/bodyTextValidationsTypes'
const initialState = {
  bodyText: '',
  positionFiles: 0,
  postMessage: '',
  sectionActive: false,
  fireDepartmentIdentifier: '',
  images: [],
  videos: [],
  onlineVideos: [],
  donateUrl: '',
  _id: '',
  sectionName: 'Donate'
}

function Donate({ fireDepartment })
{
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const menuSectionContext = useMenuSectionContext()
  const { setDonateName } = menuSectionContext.actions
  const [donateEntity, setDonateEntity] = useState(initialState)

  const [donateEntityDiscard, setDonateEntityDiscard] = useState({
    bodyText: '',
    positionFiles: 0,
    postMessage: '',
    sectionActive: true,
    fireDepartmentIdentifier: '',
    images: [],
    videos: [],
    onlineVideos: [],
    donateUrl: '',
    _id: '',
    sectionName: 'Donate'
  })

  Interceptor.interceptor(errorSnackBarActions)

  const cmsContext = useCMSContext()
  const { socket, newVideoEncoding, iarMember } = cmsContext.state
  const [errorLabel, setErrorLabel] = useState('')
  const [images, setImages] = useState([]) // this images is the one to be send in post
  const [videos, setVideos] = useState([]) // this images is the one to be send in post
  const [posting, setPosting] = useState(false) //used for preview on and off
  const [dataPosted, setDataPosted] = useState({ posted: false, message: '' })
  const [deletedFiles, setDeletedFiles] = useState([])
  const [tempUpdatedFiles, setTempUpdatedFiles] = useState([])
  const [dialog, setDialog] = useState({ open: false })
  const [loading, setLoading] = useState(true)
  const [isDiscarded, setDiscarded] = useState(false)
  const [onlineVideos, setOnlineVideos] = useState([])
  const [disabledButton, setDisabledButton] = useState(true) //used for preview on and off
  const [deletedSeconds, setDeletedSeconds] = useState([])
  const [showPublishedContent, setShowPublishedContent] = useState(true)
  const [isDiscardedMedia, setIsDiscardedMedia] = useState(false)

  //Properties for preview
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false)
  const [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(false)
  const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false)
  const [isPreviewNotSaveDialogOpen, setIsPreviewNotSavedDialogOpen] = useState(false)
  //end propertis for preview

  const {
    state: { isReadOnlyMember, appConfiguration }
  } = cmsContext

  const [donateEntityErrors, setDonateEntityErrors] = useState({})

  const [bodyText, setBodyText] = useState('')

  useEffect(() => {
    setBodyText(donateEntity.bodyText || '')
  }, [donateEntity._id, donateEntity.bodyText])

  let innerDonateChannelName = `${fireDepartment.fireDepartmentId.toString()}_inner_donate`

  const isNewVideoEncodingProcessActive = useMemo(() =>
  {
    return (
      newVideoEncoding &&
      videos?.some((x) => !donateEntityDiscard.videos.some((v) => v.fileName === x.fileName))
    )
  }, [newVideoEncoding, videos, donateEntityDiscard.videos])

  const previewedContentRef = useRef(initialState)
  const publishedContentRef = useRef(initialState)
  const previewDiscardContentRef = useRef(initialState)

  useEffect(() =>
  {
    ; (async function ()
    {
      if (fireDepartment.identifier)
      {
        const { previewed, published } = await getDonateContent()
        previewedContentRef.current = previewed
        publishedContentRef.current = published
        previewDiscardContentRef.current = cloneDeep(previewed)

        if (!appConfiguration.previewEnabled) setDisabledButton(false)
      } else
      {
        setLoading(false)
      }
    })()
  }, [appConfiguration, fireDepartment])

  useEffect(() =>
  {
    if (!showPublishedContent && appConfiguration.previewEnabled)
    {
      setDonateEntity(previewedContentRef.current)
      setDonateEntityDiscard(cloneDeep(previewDiscardContentRef.current))
      entitySetter(previewedContentRef.current, setImages, setVideos, setOnlineVideos)
    } else
    {
      setDonateEntity(publishedContentRef.current)
      setDonateEntityDiscard(cloneDeep(publishedContentRef.current))
      entitySetter(publishedContentRef.current, setImages, setVideos, setOnlineVideos)
    }
  }, [showPublishedContent])

  const getDonateContent = async () =>
  {
    let previewed = initialState
    let published = (await DonateActions.fetchDonateData(fireDepartment.identifier)) || initialState

    if (appConfiguration?.previewEnabled)
    {
      previewed =
        (await DonateActions.fetchDonateDataPreview(fireDepartment.identifier)) || initialState
    }

    let entity = showPublishedContent ? published : previewed

    if (entity)
    {
      setDonateEntity(entity)
      setDonateEntityDiscard(cloneDeep(entity))
      entitySetter(entity, setImages, setVideos, setOnlineVideos)
    }

    setLoading(false)

    return { published, previewed }
  }

  const updateDonateData = (response, isPreview) =>
  {
    previewDiscardContentRef.current = cloneDeep(response)
    //forPreview
    if (!isPreview)
    {
      publishedContentRef.current = response
      if (response.sectionName) setDonateName(response.sectionName)
      else setDonateName(donateEntity.sectionName)
    } else previewedContentRef.current = response

    //XOR validation
    //applies when show showPublishedContent is false and args.isPreview is true
    //applies when show showPublishedContent is true and args.isPreview is false
    if (!showPublishedContent === Boolean(isPreview))
    {
      setDonateEntity(response)
      setDonateEntityDiscard(cloneDeep(response))
      setImages(response.images ?? [])
      setVideos(response?.videos ?? [])
      setOnlineVideos(response?.onlineVideos ?? [])
    }
  }

  useEffect(() =>
  {
    if (fireDepartment && socket)
    {
      socket.on(innerDonateChannelName, (args) =>
      {
        console.log('CMS_inner_donate', args, new Date())

        if (args.action === 'start') setDisabledButton(true)

        if (args.action === 'saved')
        {
          // Validating if any of the videos had some errors
          if (args.message && args.message.startsWith('Videos')) processErrorMessageFromSocket(args)
          //if Publish is turn on, keep disabled
          if (Boolean(args.isPreview)) setDisabledButton(showPublishedContent)
          else setDisabledButton(false)

          // Validating if we got a section saving response
          if (args.response && args.memberId === iarMember.memberId)
            updateDonateData(args.response, args.isPreview)

          setDataPosted({ posted: true, message: 'Saved' })

          callbackSuccessForPreview()
        }

        if (args.action === 'error')
        {
          processErrorMessageFromSocket(args)
          callbackSuccessForPreview()
        }
      })
    }
    return () =>
    {
      socket.off(innerDonateChannelName)
    }
  }, [fireDepartment, iarMember.memberId, innerDonateChannelName, socket, updateDonateData])

  useEffect(() =>
  {
    if (errorLabel !== '')
    {
      errorSnackBarActions.setOpen(true, errorLabel)
    }
  }, [errorLabel])

  const processErrorMessageFromSocket = (args) =>
  {
    setErrorLabel(args.message)
    errorSnackBarActions.setOpen(true, errorLabel)
  }

  const handleChange = (evt) =>
  {
    const value = evt.target.value
    if (!showPublishedContent)
    {
      setDonateEntity((donateEntity) => ({
        ...donateEntity,
        [evt.target.name]: value
      }))
    }
    if (!appConfiguration.previewEnabled)
    {
      setDonateEntity((donateEntity) => ({
        ...donateEntity,
        [evt.target.name]: value
      }))
    }
  }

  const rteChangeHandler = (content) =>
  {
    setBodyText(content.trim())
  }

  const updateAsset = (file) =>
  {
    let itemsUpdates = [...tempUpdatedFiles]
    if (tempUpdatedFiles.filter((el) => el.fileName === file.fileName).length > 0)
    {
      itemsUpdates.filter((el) => el.fileName === file.fileName)[0].caption = file.caption
    } else
    {
      itemsUpdates.push({ caption: file.caption, fileName: file.fileName })
    }
    setTempUpdatedFiles(itemsUpdates)
  }

  const isReadyToSave = () =>
  {
    let isReady = true
    let errors = {}

    let richText = bodyText || donateEntity.bodyText

    if (!richText || EmptyTagsTypes.EmptyTag.includes(richText))
    {
      errors.errorBodyText = 'This field is required!'
      setPosting(false)
      setDisabledButton(false)
      isReady = false
    }

    // Validate Section Name
    if (!donateEntity.sectionName)
    {
      errors.errorSectionName = 'This field is required!'
      setPosting(false)
      setDisabledButton(false)
      isReady = false
    }

    setDonateEntityErrors(errors)

    setTimeout(() =>
    {
      setDonateEntityErrors({})
    }, timeout.fiveSeconds)

    if (!donateEntity.donateUrl)
    {
      errors.errorDonateUrl = 'This field is required!'
      setPosting(false)
      setDisabledButton(false)
      isReady = false
    } else
    {
      const urlMatch =
        /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/g

      if (!donateEntity.donateUrl.match(urlMatch))
      {
        setErrorLabel(`The URL of your donation pages should start with http:// or https://`)

        setInterval(() =>
        {
          setErrorLabel('')
        }, 1000)
        setPosting(false)
        setDisabledButton(false)
        isReady = false
      }
    }
    return isReady
  }

  const sendDonate = () =>
  {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    const readyToSave = isReadyToSave()

    if (!readyToSave)
    {
      setErrorLabel('Missing Information')
      setPosting(false)
      errorSnackBarActions.setOpen(true, errorLabel)
      setDataPosted({ posted: false, message: 'URL of your donation page validation' })
      return
    }
    let errors = {}

    let onlineVideoPayload = []

    if (donateEntity.onlineVideos)
    {
      onlineVideos.forEach((v) =>
      {
        onlineVideoPayload.push({
          originalName: v.originalName,
          type: 'online',
          provider: v.provider,
          caption: v.caption,
          fileSize: '',
          url: v.url
        })
      })
    } else
    {
      onlineVideoPayload = onlineVideos
    }

    let videoPayload = []
    if (donateEntity.videos)
    {
      videos.forEach((video) =>
      {
        if (video.binary)
        {
          videoPayload.push({
            originalName: video.FileName,
            caption: video.caption,
            type: video.type,
            fileSize: video.fileSize,
            binary: video.binary,
            secondsDuration: video.secondsDuration
          })
        }
      })
    } else
    {
      videoPayload = videos
    }

    let imagesPayload = []
    if (donateEntity.images)
    {
      images.forEach((image) =>
      {
        let fileExists = !donateEntity.images.some((i) =>
        {
          return i.fileName === image.fileName
        })

        if (fileExists)
        {
          imagesPayload.push({
            file: image.file,
            originalName: image.originalName,
            caption: image.caption,
            fileSize: image.fileSize,
            type: image.type
          })
        }
      })
    } else
    {
      imagesPayload = images
    }

    let url = `${window._env_.COMMUNITY_API_URL}/donates`

    const img = []
    imagesPayload.forEach((image) =>
    {
      img.push({
        originalName: image.originalName,
        caption: image.caption,
        type: image.type,
        fileSize: image.fileSize,
        file: image.file
      })
    })

    const vid = []
    videoPayload.forEach((video) =>
    {
      vid.push({
        originalName: video.originalName,
        caption: video.caption,
        type: video.type,
        fileSize: video.fileSize,
        binary: video.binary,
        secondsDuration: video.secondsDuration
      })
    })

    const online = []
    onlineVideoPayload.forEach((elem) =>
    {
      online.push({
        originalName: elem.originalName,
        caption: elem.caption,
        type: elem.type,
        provider: elem.provider,
        url: elem.url,
        fileSize: elem.fileSize,
        binary: elem.binary
      })
    })

    setDonateEntityErrors(errors)
    setTimeout(() =>
    {
      setDonateEntityErrors({})
    }, timeout.fiveSeconds)

    serviceBase.get(
      `${window._env_.COMMUNITY_API_URL}/socket-start/emit-start/${fireDepartment.fireDepartmentId}/section-name/donate`,
      GetHeaderWithToken()
    )

    const data = {
      _id: donateEntity._id || '',
      fireDepartmentIdentifier: fireDepartment.identifier,
      bodyText: bodyText,
      images: img,
      videos: vid,
      onlineVideos: online,
      positionFiles: parseInt(donateEntity.positionFiles) || 0,
      filesToDelete: deletedFiles,
      filesToUpdate: tempUpdatedFiles,
      donateUrl: donateEntity.donateUrl,
      sectionActive: donateEntity.sectionActive,
      deletedSeconds: deletedSeconds,
      sectionName: donateEntity.sectionName || 'Donate'
    }

    if (!donateEntity._id)
    {
      delete data._id
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    videos.forEach((video) =>
    {
      if (video.binary === undefined) return

      formData.append('videos', video.binary, video.originalName)

      video.binary = null
    })

    images.forEach((image) =>
    {
      if (image.file === undefined) return

      formData.append('images', image.file, image.originalName)
      image.file = null
    })

    setDonateName(donateEntity.sectionName)

    serviceBase.post(url, formData).then(
      (response) =>
      {
        setDonateEntity(response.data)
        setDonateEntityDiscard(cloneDeep(response.data))
        if (response.data.images.length > 0)
        {
          setImages(response.data.images)
        }
        if (response.data.videos.length > 0)
        {
          setVideos(response.data.videos)
        }
        if (response.data.onlineVideos.length > 0)
        {
          setOnlineVideos(response.data.onlineVideos)
        }
        setDonateName(response.data.sectionName)
        setDataPosted({ posted: true, message: 'Saved' })
        setPosting(false)
        setDeletedSeconds([])
        setDeletedFiles([])
        setTempUpdatedFiles([])
        console.log('POST Donate: ', response)
      },
      (err) =>
      {
        setDataPosted({ posted: false, message: 'Error while saving changes' })
        setPosting(false)
        console.log(err)
      }
    )
  }

  const sendDonatePreview = async () =>
  {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    const readyToSave = isReadyToSave()
    closePreviewDialog()
    if (!readyToSave)
    {
      setPosting(false)
      callbackSuccessForPreview()
      setDataPosted({ posted: false, message: 'URL of your donation page validation' })
      setErrorLabel('Missing information')
      errorSnackBarActions.setOpen(true, errorLabel)
      return
    }

    let errors = {}

    let onlineVideoPayload = []

    if (donateEntity.onlineVideos)
    {
      onlineVideos.forEach((v) =>
      {
        onlineVideoPayload.push({
          originalName: v.originalName,
          type: 'online',
          provider: v.provider,
          caption: v.caption,
          fileSize: '',
          url: v.url
        })
      })
    } else
    {
      onlineVideoPayload = onlineVideos
    }

    let imagesPayload = []
    if (donateEntity.images)
    {
      images.forEach((image) =>
      {
        let fileExists = !donateEntityDiscard.images.some((i) =>
        {
          return i.fileName === image.fileName
        })

        if (fileExists)
        {
          imagesPayload.push({
            file: image.file,
            originalName: image.originalName,
            caption: image.caption,
            fileSize: image.fileSize,
            type: image.type
          })
        }
      })
    } else
    {
      imagesPayload = images
    }

    let url = `${window._env_.COMMUNITY_API_URL}/donate-preview`

    const img = []
    imagesPayload.forEach((image) =>
    {
      img.push({
        originalName: image.originalName,
        caption: image.caption,
        type: image.type,
        fileSize: image.fileSize,
        file: image.file
      })
    })

    const vid = [] // videos are not going to be store in preview without section video process

    const online = []
    onlineVideoPayload.forEach((elem) =>
    {
      online.push({
        originalName: elem.originalName,
        caption: elem.caption,
        type: elem.type,
        provider: elem.provider,
        url: elem.url,
        fileSize: elem.fileSize,
        binary: elem.binary
      })
    })

    setDonateEntityErrors(errors)
    setTimeout(() =>
    {
      setDonateEntityErrors({})
    }, timeout.fiveSeconds)

    serviceBase.get(
      `${window._env_.COMMUNITY_API_URL}/socket-start/emit-start/${fireDepartment.fireDepartmentId}/section-name/donate`,
      GetHeaderWithToken()
    )
    const data = {
      _id: donateEntity._id || '',
      fireDepartmentIdentifier: fireDepartment.identifier,
      bodyText: bodyText,
      images: img,
      videos: vid,
      onlineVideos: online,
      positionFiles: parseInt(donateEntity.positionFiles),
      filesToDelete: deletedFiles,
      filesToUpdate: tempUpdatedFiles,
      donateUrl: donateEntity.donateUrl,
      sectionActive: donateEntity.sectionActive,
      deletedSeconds: deletedSeconds,
      sectionName: donateEntity.sectionName
    }

    if (!donateEntity._id)
    {
      delete data._id
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    images.forEach((image) =>
    {
      if (image.file === undefined) return

      formData.append('images', image.file, image.originalName)
      image.file = null
    })

    serviceBase.post(url, formData).then(
      (response) =>
      {
        setDonateEntity(response.data)
        setDonateEntityDiscard(cloneDeep(response.data))

        previewedContentRef.current = response.data
        previewDiscardContentRef.current = response.data

        setImages(response.data?.images ?? [])
        setVideos(response.data?.videos ?? [])
        setOnlineVideos(response.data?.onlineVideos ?? [])

        setDataPosted({ posted: true, message: 'Saved' })
        // setPosting(false)
        callbackSuccessForPreview()
        setDeletedSeconds([])
        setDeletedFiles([])
        setTempUpdatedFiles([])
        console.log('POST Donate preview: ', response)
      },
      (err) =>
      {
        setDataPosted({ posted: false, message: 'Error while saving changes' })
        // setPosting(false)
        callbackSuccessForPreview()
        setErrorLabel('Error while saving changes')
        errorSnackBarActions.setOpen(true, errorLabel)
        console.log(err)
      }
    )
  }

  const removeOnlineVideo = useCallback(
    (file) =>
    {
      const tempOnlineVideos = onlineVideos.filter((i) => i.originalName !== file.originalName)
      setOnlineVideos(tempOnlineVideos)
    },
    [onlineVideos]
  )

  const removeAsset = (file, type) =>
  {
    const files = deletedFiles
    const secondsDeleted = deletedSeconds
    if (!showPublishedContent)
    {
      switch (type)
      {
        case 'image':
          if (!file.isNew)
          {
            files.push(file.fileName)
            setDeletedFiles(files)
          }

          const tempImages = images.filter((i) => i.fileName !== file.fileName)
          setImages(tempImages)
          break
        case 'video':
          if (!file.isNew)
          {
            files.push(file.fileName)
            secondsDeleted.push(file.secondsDuration ? file.secondsDuration : 0)
            setDeletedFiles(files)
            setDeletedSeconds(secondsDeleted)
          }
          const tempVideos = videos.filter((i) => i.fileName !== file.fileName)
          setVideos(tempVideos)
          break
        default:
          break
      }
    }

    if (!appConfiguration.previewEnabled)
    {
      switch (type)
      {
        case 'image':
          if (!file.isNew)
          {
            files.push(file.fileName)
            setDeletedFiles(files)
          }

          const tempImages = images.filter((i) => i.fileName !== file.fileName)
          setImages(tempImages)
          break
        case 'video':
          if (!file.isNew)
          {
            files.push(file.fileName)
            secondsDeleted.push(file.secondsDuration ? file.secondsDuration : 0)
            setDeletedFiles(files)
            setDeletedSeconds(secondsDeleted)
          }
          const tempVideos = videos.filter((i) => i.fileName !== file.fileName)
          setVideos(tempVideos)
          break
        default:
          break
      }
    }
  }

  const sectionActiveChange = useCallback(() =>
  {
    setDonateEntity((donateEntity) => ({
      ...donateEntity,
      sectionActive: !donateEntity.sectionActive
    }))
  }, [])

  const switchContent = () =>
  {
    setDonateEntityErrors({})
    setErrorLabel('')
    if (!showPublishedContent)
    {
      previewedContentRef.current = {
        ...donateEntity,
        videos,
        images,
        onlineVideos,
        bodyText
      }
    }
    setShowPublishedContent((prev) => !prev)
    setDiscarded((prevState) => !prevState)
    setDisabledButton((prevState) => !prevState)
  }

  const openConfirmationDialog = () =>
  {
    setDialog({ open: true })
    setDiscarded(false)
  }

  const cancelDialog = () =>
  {
    setDialog({ open: false })
    setDiscarded(false)
  }

  const discardChanges = () =>
  {
    setDialog({ open: false })
    setDonateEntity(cloneDeep(donateEntityDiscard))
    setImages(cloneDeep(donateEntityDiscard.images))
    setVideos(cloneDeep(donateEntityDiscard.videos))
    setOnlineVideos(cloneDeep(donateEntityDiscard.onlineVideos))
    setDeletedFiles([])
    setIsDiscardedMedia((prev) => !prev)
    setDiscarded((prevState) => !prevState)
    setTempUpdatedFiles([])
  }

  const processSectionVideoProcessSaving = async (isPreview) =>
  {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    setDisabledButton(true)
    closePreviewDialog()
    const readyToSave = isReadyToSave()
    if (!readyToSave)
    {
      setPosting(false)
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      return
    }
    // Socket IO
    await emitSocketMessage()

    // Creating payload data
    let data = getDonateData(isPreview)

    if (!isPreview) setDonateName(donateEntity.sectionName)

    // Get added videos
    const newVideos = processAndGetVideos()

    // Set number of new videos
    if (newVideos && newVideos.length > 0) data.videosNumber = newVideos.length

    // Saving section video process
    const response = await saveSectionVideoProcess(data, newVideos, images)

    // Section video process response validation
    if (!response.sectionVideoProcessResponse || !response.sectionVideoProcessResponse._id)
    {
      setDataPosted({ posted: false, message: 'Error while saving changes' })
      errorSnackBarActions.setOpen(true)
      setPosting(false)
      setDisabledButton(false)
      if (isPreview) callbackSuccessForPreview()
    }

    // Encoder call response validation
    if (response.encoderErrors && response.encoderErrors.length > 0)
    {
      setErrorLabel('There was an error uploading these files: ', response.encoderErrors.join(','))
      errorSnackBarActions.setOpen(true, errorLabel)
      setPosting(false)
      setDisabledButton(false)
      if (isPreview) callbackSuccessForPreview()
    }

    setDeletedSeconds([])
    setDeletedFiles([])
  }

  const emitSocketMessage = async () =>
  {
    serviceBase.get(
      `${window._env_.COMMUNITY_API_URL}/socket-start/emit-start/${fireDepartment.fireDepartmentId}/section-name/donate`,
      GetHeaderWithToken()
    )
  }

  const getDonateData = (setPreviewType) =>
  {
    const data = {
      identifier: fireDepartment.identifier || '',
      richText: bodyText,
      images: processAndGetImages(),
      onlineVideos: processAndGetOnlineVideos(),
      positionFiles: parseInt(donateEntity.positionFiles),
      deletedFiles: deletedFiles,
      updatedFiles: tempUpdatedFiles,
      donateUrl: donateEntity.donateUrl,
      sectionActive: donateEntity.sectionActive,
      deletedSeconds: deletedSeconds,
      sectionName: donateEntity.sectionName,
      type: setPreviewType ? EncondingSectionType.DonatePreview : EncondingSectionType.Donate,
      socketChannels: [
        innerDonateChannelName,
        `${fireDepartment.fireDepartmentId.toString()}_donate`
      ],
      memberId: iarMember.memberId,
      fireDepartmentId: fireDepartment.fireDepartmentId,
      timezone: fireDepartment.timezone,
      iarMemberFullName: iarMember.fullName,
      contentId: donateEntity._id,
      title: donateEntity.sectionName
    }
    if (!donateEntity._id)
    {
      delete data._id
    }
    return data
  }

  const processAndGetImages = () =>
  {
    let imagesPayload = []

    if (donateEntity.images)
    {
      images.forEach((image) =>
      {
        if (image.file === undefined) return

        let fileExists = !donateEntityDiscard.images.some((i) =>
        {
          return i.fileName === image.fileName
        })

        if (fileExists)
        {
          imagesPayload.push({
            file: image.file,
            originalName: image.originalName,
            caption: image.caption,
            fileSize: image.fileSize,
            type: image.type
          })
        }
      })
    } else
    {
      imagesPayload = images
    }

    return imagesPayload
  }

  const processAndGetVideos = () =>
  {
    let videosPayload = []

    if (donateEntity.videos)
    {
      videos.forEach((video) =>
      {
        if (video.binary)
        {
          videosPayload.push({
            originalName: video.FileName,
            caption: video.caption,
            type: video.type,
            fileSize: video.fileSize,
            binary: video.binary,
            secondsDuration: video.secondsDuration
          })
        }
      })
    } else
    {
      videosPayload = videos
    }

    return videosPayload
  }

  const processAndGetOnlineVideos = () =>
  {
    let onlineVideosPayload = []

    if (donateEntity.onlineVideos)
    {
      onlineVideos.forEach((v) =>
      {
        onlineVideosPayload.push({
          originalName: v.originalName,
          type: 'online',
          provider: v.provider,
          caption: v.caption,
          fileSize: '',
          url: v.url
        })
      })
    } else
    {
      onlineVideosPayload = onlineVideos
    }

    return onlineVideosPayload
  }

  let DonateContentChanged = false
  if (
    JSON.stringify(donateEntity) !== JSON.stringify(donateEntityDiscard) ||
    JSON.stringify(images) !== JSON.stringify(donateEntity.images) ||
    JSON.stringify(videos) !== JSON.stringify(donateEntity.videos) ||
    JSON.stringify(onlineVideos) !== JSON.stringify(donateEntity.onlineVideos)
  )
  {
    DonateContentChanged = true
  }

  let DonatePreviewContentChanged = false
  if (
    JSON.stringify(donateEntity) !== JSON.stringify(previewDiscardContentRef.current) ||
    JSON.stringify(images) !== JSON.stringify(previewDiscardContentRef.current.images) ||
    JSON.stringify(videos) !== JSON.stringify(previewDiscardContentRef.current.videos) ||
    JSON.stringify(onlineVideos) !== JSON.stringify(previewDiscardContentRef.current.onlineVideos)
  )
  {
    if (
      !showPublishedContent &&
      appConfiguration.previewEnabled &&
      Object.keys(previewDiscardContentRef.current).length
    )
    {
      DonatePreviewContentChanged = true
    }
  } else
  {
    DonatePreviewContentChanged = false
  }

  const closeDiscardDialog = () =>
  {
    setIsDiscardDialogOpen(false)
  }

  const closeSaveDialog = () =>
  {
    setIsSaveDialogOpen(false)
  }

  const closePreviewDialog = () =>
  {
    setIsPreviewDialogOpen(false)
  }

  const openDiscardDialog = () =>
  {
    setIsDiscardDialogOpen(true)
  }

  const openSaveDialog = () =>
  {
    setIsSaveDialogOpen(true)
  }

  const openPreviewDialog = () =>
  {
    setIsPreviewDialogOpen(true)
  }

  const callbackSuccessForPreview = () =>
  {
    setPosting(false)
  }

  const openNotSavedPreviewDialog = () =>
  {
    setIsPreviewNotSavedDialogOpen(true)
  }

  const closeNotSavedPreviewDialog = () =>
  {
    setIsPreviewNotSavedDialogOpen(false)
  }

  const publishButtonValidations = () =>
  {
    if (
      JSON.stringify(donateEntity) !== JSON.stringify(donateEntityDiscard) ||
      bodyText !== donateEntityDiscard.bodyText ||
      JSON.stringify(videos) !== JSON.stringify(donateEntity.videos) ||
      JSON.stringify(images) !== JSON.stringify(donateEntity.images) ||
      JSON.stringify(onlineVideos) !== JSON.stringify(donateEntity.onlineVideos)
    )
    {
      openNotSavedPreviewDialog()
      return
    } else
    {
      openSaveDialog()
    }
  }

  const publishPost = async () =>
  {
    closeSaveDialog()
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)

    const response = await DonateActions.postPublishDonate(donateEntity.fireDepartmentIdentifier)
    if (response)
    {
      publishedContentRef.current = response
      previewDiscardContentRef.current = response
      previewedContentRef.current = response
      setDonateEntity(response)
      setDonateEntityDiscard(cloneDeep(response))

      setImages(response.images ?? [])
      setVideos(response.videos ?? [])
      setOnlineVideos(response.onlineVideos ?? [])

      setDonateName(response.sectionName)
      setDataPosted({ posted: true, message: 'Saved' })
      setDeletedSeconds([])
      setDeletedFiles([])
      setTempUpdatedFiles([])
    } else
    {
      setErrorLabel('There was an error Publishing Donate')
      errorSnackBarActions.setOpen(true, errorLabel)
    }

    callbackSuccessForPreview()
  }

  return (
    <div className="App donate">
      <IARDialog
        open={isPreviewNotSaveDialogOpen}
        title="Save Preview first"
        content="Please save your changes in preview before publishing"
        onOk={closeNotSavedPreviewDialog}
        onCancel={closeNotSavedPreviewDialog}
        previewNotSaved={true}
      />
      <div className="page-header" id="donationsTitle">
        Menu Section - {donateEntity.sectionName}
      </div>
      {loading && <LoadingSpinner />}
      {!loading && (
        <>
          <IARDialog
            open={dialog.open}
            title="Confirm"
            content="Do you want to discard your changes?"
            onOk={discardChanges}
            onCancel={cancelDialog}
          />
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid size={12}>
                <div className="page-description">
                  This is an optional page that you can use to help raise funds for your
                  organization. Provide compelling reasons for why you need donations and how they
                  can help you serve your community, add any helpful image or video files (e.g.
                  showing you in action or showing things that you are fundraising for), and then
                  add a url for any donation site that you use (e.g. a PayPal or Square payment
                  page).
                </div>
              </Grid>
              <Grid size={12}>
                <form className="page-content" noValidate autoComplete="off">
                  <Grid container>
                    <Grid size={12} className="container-field">
                      {appConfiguration.previewEnabled && (
                        <div>
                          <span>Display Content as PREVIEW MODE</span>
                          <CustomSwitch
                            name="showPublished"
                            value={!showPublishedContent}
                            sectionActiveChange={switchContent}
                            useYesNoButtons={true}
                          />
                          <PreviewContentLabel
                            showPublished={showPublishedContent}
                            previewEnabled={appConfiguration.previewEnabled}
                          />
                        </div>
                      )}
                      <div>
                        <span>Section Visible on MyLS App</span>
                        <CustomSwitch
                          name="sectionActive"
                          value={Boolean(donateEntity.sectionActive)}
                          sectionActiveChange={sectionActiveChange}
                          useYesNoButtons={true}
                          disabled={appConfiguration?.previewEnabled && showPublishedContent}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid size={12} className="container-field">
                    <label htmlFor="sectionName">Section Name</label> <br />
                    <label htmlFor="error" className="error-text">
                      {donateEntityErrors.errorSectionName}
                    </label>
                    <TextField
                      id="sectionName"
                      name="sectionName"
                      variant="outlined"
                      className="donateUrl"
                      value={donateEntity.sectionName}
                      onChange={handleChange}
                      disabled={appConfiguration.previewEnabled && showPublishedContent}
                    />
                  </Grid>
                  <br />

                  <Grid size={12} className="container-field">
                    <label htmlFor="message">Body text</label> <br />
                    <label htmlFor="error" className="error-text">
                      {donateEntityErrors.errorBodyText}
                    </label>
                    <IARRte
                      onChange={rteChangeHandler}
                      content={donateEntity.bodyText}
                      discarded={isDiscarded}
                      disableHandleChange={appConfiguration.previewEnabled && showPublishedContent}
                    />
                  </Grid>
                  <Grid size={12} className="container-field dropdown-container">
                    <div>
                      <label htmlFor="positionFiles">Position images and videos</label> <br />
                      <CustomDropdown
                        name="positionFiles"
                        value={donateEntity.positionFiles || 0}
                        onChange={handleChange}
                        disableHandleChange={
                          appConfiguration.previewEnabled && showPublishedContent
                        }
                      />
                    </div>
                  </Grid>
                  <Grid container>
                    <Grid size={12}>
                      <Grid className="container-field">
                        <label htmlFor="images" className="body-text">
                          Media Files
                        </label>
                        <MediaFilesMessage max={5}></MediaFilesMessage>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseImage
                        images={images}
                        setImages={setImages}
                        fireDepartmentIdentifier={donateEntity.fireDepartmentIdentifier}
                        max={5}
                        elementsAdded={images.length + videos.length}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      ></ChooseImage>
                      {images.map((image, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="image"
                          key={[image.fileName, image.caption, index].join('-')}
                          media={image}
                          removeMediaEvent={removeAsset}
                          onUpdate={updateAsset}
                          disableHandleClick={
                            appConfiguration.previewEnabled && showPublishedContent
                          }
                        />
                      ))}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseVideo
                        videos={videos}
                        setVideos={setVideos}
                        fireDepartmentIdentifier={donateEntity.fireDepartmentIdentifier}
                        max={5}
                        elementsAdded={images.length + videos.length}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      ></ChooseVideo>
                      {videos?.map((video, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="video"
                          key={[video.fileName, video.caption, index].join('-')}
                          media={video}
                          removeMediaEvent={removeAsset}
                          index={index}
                          onUpdate={updateAsset}
                          disableHandleClick={
                            appConfiguration.previewEnabled && showPublishedContent
                          }
                        />
                      ))}
                    </Grid>
                    <Grid size={12} className="media-files">
                      <OnlineVideos
                        videos={onlineVideos}
                        setOnlineVideos={setOnlineVideos}
                        setErrorLabel={setErrorLabel}
                        max={5}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      />
                      {onlineVideos?.map((onlineVideo, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="online"
                          key={[onlineVideo.fileName, onlineVideo.caption, index].join('-')}
                          media={onlineVideo}
                          removeMediaEvent={removeAsset}
                          index={index}
                          subType={videoTypes.YoutubeVideos}
                          onUpdate={updateAsset}
                          removeOnlineVideo={removeOnlineVideo}
                          disableHandleClick={
                            appConfiguration.previewEnabled && showPublishedContent
                          }
                        />
                      ))}
                    </Grid>
                  </Grid>
                  <Grid size={12} className="container-field">
                    <label htmlFor="donateUrl">URL of your donation page</label> <br />
                    <label htmlFor="error" className="error-text">
                      {donateEntityErrors.errorDonateUrl}
                    </label>
                    <TextField
                      id="donateUrl"
                      name="donateUrl"
                      variant="outlined"
                      className="donateUrl"
                      value={donateEntity.donateUrl}
                      onChange={handleChange}
                      disabled={appConfiguration.previewEnabled && showPublishedContent}
                    />
                  </Grid>
                  <Grid size={12} className="container container-buttons">
                    {appConfiguration && !appConfiguration.previewEnabled ? (
                      <div className="save-button-container">
                        <ButtonSave
                          id="saveButton"
                          disabled={isReadOnlyMember || disabledButton}
                          loading={posting}
                          onClickCallback={() =>
                          {
                            if (isNewVideoEncodingProcessActive)
                              processSectionVideoProcessSaving(false)
                            else sendDonate()
                          }}
                        />
                        <Button
                          style={{ maxWidth: '250px', minWidth: '250px' }}
                          disabled={isReadOnlyMember || disabledButton}
                          variant="outlined"
                          id="cancelButtonEntity"
                          color="primary"
                          size="medium"
                          onClick={openConfirmationDialog}
                        >
                          Discard
                        </Button>
                        {dataPosted.posted && <SavedMessage message={dataPosted.message} />}
                      </div>
                    ) : (
                      <PrepublishButtons
                        isReadOnlyMember={isReadOnlyMember}
                        disabledButton={disabledButton}
                        isShown={appConfiguration.previewEnabled}
                        discardChanges={discardChanges}
                        savePreview={() =>
                        {
                          if (isNewVideoEncodingProcessActive)
                            processSectionVideoProcessSaving(true)
                          else sendDonatePreview()
                        }}
                        savePublish={publishPost}
                        closeDiscardDialog={closeDiscardDialog}
                        isPreviewDialogOpen={isPreviewDialogOpen}
                        isSaveDialogOpen={isSaveDialogOpen}
                        closeSaveDialog={closeSaveDialog}
                        isDiscardDialogOpen={isDiscardDialogOpen}
                        closePreviewDialog={closePreviewDialog}
                        posting={posting}
                        openPreviewDialog={openPreviewDialog}
                        openDiscardDialog={openDiscardDialog}
                        publishButtonValidations={publishButtonValidations}
                      />
                    )}
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </div>
  )
}

export default Donate
